import * as yup from 'yup'

import constants from 'constants/index'

const schemaProfile = (profileType, isEdit) => {
  const { PROFILE_TYPE_ADVISOR, PROFILE_TYPE_CLIENT } = constants.user

  const isClient = profileType === PROFILE_TYPE_CLIENT
  const isAdvisor = profileType === PROFILE_TYPE_ADVISOR

  return yup.object().shape({
    name: yup
      .string()
      .max(100)
      .trim()
      .when('originProfileId', {
        is: false,
        then: yup.string().max(100).trim().required(),
      }),
    description: yup.string().trim().required(),
    companyId:
      isClient && !isEdit
        ? yup.object().required().typeError('Preencha esse campo')
        : yup.object().notRequired(),
    organizationId:
      isAdvisor && !isEdit
        ? yup.object().required().typeError('Preencha esse campo')
        : yup.object().notRequired(),
  })
}

export default schemaProfile
